import { render, staticRenderFns } from "./PlansBillings.vue?vue&type=template&id=ef9f7014&scoped=true&"
import script from "./PlansBillings.vue?vue&type=script&lang=js&"
export * from "./PlansBillings.vue?vue&type=script&lang=js&"
import style0 from "./PlansBillings.vue?vue&type=style&index=0&id=ef9f7014&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9f7014",
  null
  
)

export default component.exports